/*
 * COLLECTION STUDIO · "Añadir" desde las fichas (secciones CS).
 * Añade al carrito sin cambiar de página y avisa al tema (Horizon 3.x) con el
 * mismo evento que usan sus propios botones, para que se actualicen el número
 * del carrito y el cajón. Si algo falla antes de enviar, el formulario se envía
 * de la forma normal y Shopify lleva al carrito.
 */
import { CartAddEvent } from '@theme/events';

const routes = () => (window.Theme && window.Theme.routes) || {};

async function quickAdd(form) {
  const button = form.querySelector('[type="submit"]');
  const message = form.querySelector('.cs-qa__msg');
  const formData = new FormData(form);
  const id = String(formData.get('id'));
  const quantity = Number(formData.get('quantity') || 1);
  const label = button.textContent;

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  button.disabled = true;
  if (message) message.hidden = true;
  try {
    const response = await fetch(routes().cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    }).then((r) => r.json());

    if (response.status) throw new Error(response.description || response.message || 'No se ha podido añadir.');

    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    form.dispatchEvent(
      new CartAddEvent(cart, id, {
        source: 'cs-quick-add',
        itemCount: quantity,
        variantId: id,
        sections: response.sections,
      })
    );

    button.textContent = form.dataset.added || 'Añadido ✓';
    button.classList.add('is-added');
    setTimeout(() => {
      button.textContent = label;
      button.classList.remove('is-added');
    }, 2500);
  } catch (error) {
    if (message) {
      message.textContent = error.message;
      message.hidden = false;
    }
  } finally {
    button.disabled = false;
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-cs-quick-add')) return;
  event.preventDefault();
  quickAdd(form).catch(() => form.submit());
});
